document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".image-gallery");
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const sectionId = gallery.dataset.sectionId;
    const baseCycleSpeed = parseInt(gallery.dataset.cycleSpeed, 10) || 5000;
    const items = gallery.querySelectorAll(".image-gallery__item");
    if (items.length === 0) return;

    const dataScript = gallery.querySelector(".image-gallery-data");
    if (!dataScript) return;

    let allImages = [];
    try {
      allImages = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error("Failed to parse image gallery data", e);
      return;
    }

    if (allImages.length === 0) return;

    let currentImages = Array.from(items).map((item) => {
      const img = item.querySelector(".image-gallery__image");
      return img ? img.src : null;
    });

    const intervals = [];

    function shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }

    function getNextImage(excludeSrcs = []) {
      const available = allImages.filter(
        (img) => !excludeSrcs.includes(img.src)
      );

      if (available.length === 0) {
        const shuffled = shuffleArray([...allImages]);
        return shuffled[0];
      }

      return available[Math.floor(Math.random() * available.length)];
    }

    function updateImage(item, newImage, slotIndex) {
      const img = item.querySelector(".image-gallery__image");
      if (!img) return;

      img.classList.add("fade-out");
      img.classList.remove("fade-in");

      setTimeout(() => {
        img.src = newImage.src;
        img.alt = newImage.alt;

        currentImages[slotIndex] = newImage.src;

        img.classList.remove("fade-out");
        img.classList.add("fade-in");
      }, 2000);
    }

    function cycleSingleImage(item, slotIndex) {
      const displayedImages = currentImages.filter(Boolean);
      
      const nextImage = getNextImage(displayedImages);

      updateImage(item, nextImage, slotIndex);
    }

    items.forEach((item, index) => {
      const img = item.querySelector(".image-gallery__image");
      if (!img) return;

      const randomOffset = Math.random() * baseCycleSpeed;
      
      const speedVariation = 0.9 + Math.random() * 0.2; 
      const individualSpeed = baseCycleSpeed * speedVariation;

      setTimeout(() => {
        const interval = setInterval(() => {
          cycleSingleImage(item, index);
        }, individualSpeed);
        
        intervals.push(interval);
      }, randomOffset);
    });

    window.addEventListener("beforeunload", () => {
      intervals.forEach((interval) => clearInterval(interval));
    });
  });
});

